import { jsxs as e, jsx as t } from "react/jsx-runtime";

import { useContext as s } from "react";

import r from "@ui-components-3/icons/lib/duotone/CircleXmark";

import o from "../../../utils/classNames/index.js";

import l from "../context/index.js";

const i = ({children: i, className: n, ...a}) => {
    const {softClose: m, labelId: c} = s(l);
    return e("div", {
        ...a,
        className: o("p-m flex items-start justify-between", n),
        children: [ t("h2", {
            id: c,
            className: "typography-body-xxl text-neutral font-semibold",
            children: i
        }), t("button", {
            className: "btn-unsized btn-neutral-borderless ml-xs",
            type: "button",
            onClick: m,
            children: t(r, {
                className: "h-m w-m fill-neutral",
                "aria-hidden": "true"
            })
        }) ]
    });
};

export { i as default };
//# sourceMappingURL=index.js.map
